import merge from 'lodash/merge.js'
/**
 * Get config override from session storage
 */
export function getSessionOverrideConfig<TAppConfig>(): TAppConfig {
  let sessionConfig = {} as TAppConfig
  try {
    // eslint-disable-next-line n/no-unsupported-features/node-builtins -- this is a browser environment
    const configJson = window.sessionStorage.getItem('config')
    sessionConfig = configJson ? JSON.parse(configJson) : {}
  } catch {
    /* do nothing */
  }
  return sessionConfig
}

/**
 * Build configuration
 */
type BuildConfigProps<TAppConfig, TAdditionalConfig = object> = {
  baseConfig: TAppConfig

  additionalConfig: (config: TAppConfig) => TAdditionalConfig
}
export function buildConfig<TAppConfig, TAdditionalConfig>({
  baseConfig,
  additionalConfig,
}: BuildConfigProps<TAppConfig, TAdditionalConfig>): TAppConfig & TAdditionalConfig {
  // In e2e tests we can override the config by setting a JSON serialized object in session storage
  // When defined, we'll merge this override with the existing value on window.__dhlConfig
  const sessionConfig = getSessionOverrideConfig<TAppConfig>()

  // intermediate config
  const intermediateConfig = merge({}, baseConfig, sessionConfig)

  const config = merge({}, baseConfig, sessionConfig, additionalConfig(intermediateConfig))
  return config
}
